import { render, staticRenderFns } from "./CustomOrgTree.vue?vue&type=template&id=5781fb33&scoped=true"
import script from "./CustomOrgTree.vue?vue&type=script&lang=js"
export * from "./CustomOrgTree.vue?vue&type=script&lang=js"
import style0 from "./CustomOrgTree.vue?vue&type=style&index=0&id=5781fb33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5781fb33",
  null
  
)

export default component.exports